import type { Dictionary } from './en'

export const de: Dictionary = {
    nav: {
        templates: 'Vorlagen',
        insights: 'Einblicke',
        cloneable: 'Cloneable',
        faq: 'FAQ',
        contact: 'Kontakt',
        allAccess: 'All-Access 95% Rabatt',
        store: 'Store',
        moreStuff: 'Mehr coole Tools',
        topBanner: '95% RABATT auf ALLE Vorlagen',
        notification: '1 GRATIS Webflow-Vorlage bei je 2 Käufen – Jetzt sichern! 💙🎉😍'
    },
    home: {
        badgeOff: '95% RABATT',
        badgePages: '1.300+ einzigartige Seiten',
        heroTitle: 'Schnell Websites bauen. Viel sparen',
        heroSubtitle: 'Erhalte täglichen Zugriff auf Hunderte Premium-Webflow-Vorlagen — einmal zahlen, viele Websites bauen.',
        heroCta: 'Alles freischalten – 95% RABATT',
        allAccessTitle: 'All-Access-Pass',
        allAccessLead: 'Hol dir All-Access für die',
        allAccessLeadStrong: 'gesamte Bibliothek zum Preis von 1 Vorlage',
        allAccessMid: 'steigere deine Produktivität mit sofortigem Zugriff auf alle',
        allAccessStrong2: '216 Vorlagen',
        allAccessTail: 'und monatlich neue Releases.',
        allAccessCta: 'All-Access freischalten',
        categories: 'Kategorien',
        tags: 'Tags',
        allCategories: 'Alle Kategorien',
        allTags: 'Alle Tags',
        searchCategories: 'Kategorien suchen…',
        searchTags: 'Tags suchen…',
        noResults: 'Keine Ergebnisse gefunden.',
        subscribeToDownload: 'Zum Download abonnieren',
        previous: 'Zurück',
        next: 'Weiter',
        noItems: 'Keine Einträge gefunden.',
        loadMore: 'Mehr laden',
        emptyTitle: 'Keine Vorlagen entsprechen diesen Filtern',
        emptyBody: 'Entferne einen Filter oder erweitere deine Suche – oder durchstöbere die gesamte Bibliothek, um deine perfekte Webflow-Vorlage zu finden.',
        clearFilters: 'Filter zurücksetzen',
        browseAll: 'Alle Vorlagen ansehen'
    },
    footer: {
        tagline: 'Wir erstellen Webflow-Vorlagen, die performen & konvertieren.',
        product: 'Produkt',
        unlockAllAccess: 'All-Access freischalten',
        templates: 'Vorlagen',
        ourFlow: 'Unser Flow',
        insights: 'Einblicke',
        giveaway: "Sep '23 Gewinnspiel 🎉",
        cloneable: 'Cloneable',
        tags: 'Tags',
        affiliate: 'Partnerprogramm',
        other: 'Sonstiges',
        contact: 'Kontakt',
        privacy: 'Datenschutz',
        faq: 'FAQ',
        followUs: 'Folge uns',
        topCategories: 'Top-Kategorien',
        topTags: 'Top-#Tags',
        mission: 'Unsere Mission: die Magie des Programmierens ermöglichen, ohne programmieren zu lernen.',
        emailPlaceholder: 'E-Mail-Adresse',
        subscribe: 'Abonnieren',
        subscribeSuccess: 'Danke! Bitte bestätige in deinem Postfach.',
        subscribeError: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.'
    },
    templateDetail: {
        otherTemplates: 'Weitere',
        otherTemplatesAccent: 'Webflow',
        otherTemplatesTail: 'Vorlagen',
        webflow: 'Webflow',
        templateWord: 'Vorlage',
        buyOnWebflow: 'Auf Webflow kaufen',
        getThisMore: 'Hol dir diese + 215 weitere für 69 $',
        orPreviewIn: 'Oder Vorschau in',
        browser: 'Browser',
        designer: 'Designer'
    },
    testimonials: {
        heading: 'Man liebt, was',
        headingAccent: 'wir tun'
    },
    blog: {
        readBlogPost: 'Beitrag lesen',
        insightsAccent: 'Einblicke',
        fromWord: 'von',
        categoryWord: 'Kategorie',
        otherInsights: 'Weitere',
        otherInsightsAccent: 'Einblicke',
        mostRead: 'Meistgelesene Artikel:',
        author: 'Autor:',
        published: 'Veröffentlicht',
        updated: 'Aktualisiert',
        categoryLabel: 'Kategorie',
        share: 'Teilen',
        subscribeInspo: 'Wedoflow Inspo abonnieren'
    },
    contact: {
        title: 'Brauchst du Hilfe mit deiner Website?',
        subtitle: 'Stell Fragen, teile deine Arbeit oder chatte mit unserem Team, schreib uns einfach.',
        startConversation: 'Starte das Gespräch',
        getInTouch: 'Kontaktiere uns',
        emailPlaceholder: 'Deine E-Mail',
        companyPlaceholder: 'Firmenname',
        messagePlaceholder: 'Nachricht',
        submit: 'Absenden',
        sending: 'Bitte warten...',
        success: 'Danke! Deine Nachricht ist eingegangen!',
        error: 'Ups! Beim Absenden ist etwas schiefgelaufen.'
    },
    marketplace: {
        otherTemplates: 'Weitere Webflow',
        otherTemplatesAccent: 'Vorlagen'
    },
    common: {
        loading: 'Wird geladen…',
        backToHome: 'Zurück zur Startseite',
        readMore: 'Mehr lesen',
        viewTemplate: 'Vorlage ansehen',
        from: 'Ab',
        notFoundTitle: 'Seite nicht gefunden',
        notFoundText: 'Die gesuchte Seite existiert nicht oder wurde verschoben.'
    }
}
